import { Card, CardContent, makeStyles, Typography, CircularProgress, Checkbox } from '@material-ui/core'
import { standardizeStartOfDateUTC } from '../../utils'
import { gray } from '../../utils/colors'
import PetAvatar from '../Common/PetAvatar'

const useStyles = makeStyles(() => ({
	root: { paddingTop: '24px', paddingBottom: '24px', position: 'relative' },
	cardContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: '1.5rem'
	},
	overline: {
		fontSize: '1rem',
		fontWeight: 800,
		fontFamily: 'Nunito',
		color: gray[900]
	},
	spinnerContainer: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.6)'
	},
	attendanceContainer: { border: `1px solid ${gray[400]}`, borderRadius: '6px', padding: '1rem' },
	attendanceRowContainer: {
		display: 'flex',
		gap: '0.5rem',
		alignItems: 'center',
		marginTop: '0.5rem'
	},
	attendanceStatus: {
		textTransform: 'uppercase'
	}
}))

const TrainingEnrollmentAttendanceCard = ({ enrollment, loading = false }) => {
	const classes = useStyles()

	return (
		<Card className={classes.root}>
			{loading ? (
				<div className={classes.spinnerContainer}>
					<CircularProgress />
				</div>
			) : null}

			<CardContent className={classes.cardContent}>
				<PetAvatar
					imageUrl={enrollment?.pet?.image_url}
					petName={enrollment?.pet?.name}
					link={`/clients/${enrollment?.household_id}/pets/${enrollment?.pet?._id}`}
				/>
				<div className={classes.attendanceContainer}>
					<Typography className={classes.overline}>Session Attendance</Typography>
					{enrollment?.attendance?.map((s) => {
						const { status, session, session_date, class_cancelled = false } = s
						return (
							<div className={classes.attendanceRowContainer}>
								<Checkbox
									value={null}
									checked={status.id === 4}
									disabled={true}
									onChange={() => null}
								/>
								<span>
									Session {session} -{' '}
									{standardizeStartOfDateUTC(session_date).format('MMM DD, YYYY')}
								</span>
								{class_cancelled ? (
									<span className={classes.attendanceStatus}>(Class Cancelled)</span>
								) : null}
								{status.id > 1 && !class_cancelled ? (
									<span className={classes.attendanceStatus}>({status.name})</span>
								) : null}
							</div>
						)
					})}
				</div>
			</CardContent>
		</Card>
	)
}

export default TrainingEnrollmentAttendanceCard
